import personnelIndex from '../../pages/personnel'

const personnelRoute = [
  {
    path: '/personnel',
    name: 'personnel',
    component: personnelIndex
  }
]

export default personnelRoute



// WEBPACK FOOTER //
// ./src/router/personnel/index.js